import {
  QSetCommentProvider,
  QSetReviewSubtaskPageHeader,
} from '@exam-management/qset-review-subtask-details';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function ReviewResultLayout() {
  const { subTaskId } = useParams(
    '/task-management/qset-review/:taskId/subtask/:subTaskId/review-result',
  );

  return (
    <QSetCommentProvider taskId={subTaskId}>
      <QSetReviewSubtaskPageHeader />
      <Outlet />
    </QSetCommentProvider>
  );
}
